// Copyright 2017-2021 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { isNumber } from "../is/number.js";
import { objectSpread } from "../object/spread.js";
import { u8aToHex } from "../u8a/index.js";
import { bnToU8a } from "./toU8a.js";
const ZERO_STR = '0x00';

function bnToHex(value, arg1 = {
  bitLength: -1,
  isLe: false,
  isNegative: false
}, arg2) {
  if (!value) {
    return ZERO_STR;
  }

  return u8aToHex(bnToU8a(value, objectSpread({
    isLe: false,
    isNegative: false
  }, isNumber(arg1) ? {
    bitLength: arg1,
    isLe: arg2
  } : arg1)));
}

export { bnToHex };